/**
 * @generated SignedSource<<3cc8b78563c611dd297b1059ef93fde2>>
 * @relayHash 2f08b7d362c1ac125acc54fa82cc013a
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2f08b7d362c1ac125acc54fa82cc013a

import { ConcreteRequest } from 'relay-runtime';
export type TopIndependentStatus = "DISCOVERED" | "OPTED_IN" | "OPTED_OUT" | "UNDISCOVERED" | "%future added value";
export type UserGroup = "ADMIN" | "BLOCKED_USER" | "BOTSTACKS_EXPERT" | "BUBBLE_EXPERT" | "BUILDSHIP_EXPERT" | "C4C_REFERRAL_PROGRAM" | "CLIENT_ONBOARDING_COMPLETE" | "CLIENT_REFERRAL_PILOT" | "COMMUNITY_FEED_BANNED_FROM_POSTING" | "COMMUNITY_FEED_CREATOR" | "COMMUNITY_FEED_CURATOR" | "COMMUNITY_FEED_MEMBER" | "COMMUNITY_FEED_VIEWER" | "COMMUNITY_MANAGER" | "CONTRACTOR_ONBOARDING_COMPLETE" | "CONTRACTOR_PROFILE_COMPLETE" | "CONTRA_EXPERT_TEST" | "CONTRA_FOR_COMPANIES_CLIENT" | "CONTRA_PRO_ACCESS_CODE_EVENT" | "CONTRA_PRO_OLD_PRICE_GROUP" | "CONTRA_TEAM_MEMBER" | "CREATOR_PORTFOLIO_EARLY_ACCESS" | "DESCRIPT_EXPERT" | "EXCLUDED_FROM_DISCOVER" | "EXCLUDED_FROM_MATCHING" | "FLAGGED_USER" | "FLAG_FOR_IMPROVEMENT" | "FLUTTERFLOW_EXPERT" | "FRAMER_AD_EXPERIMENT_ANALYTICS_TAB_AUDIENCE" | "FRAMER_AD_EXPERIMENT_EXPERT_PAGE_AUDIENCE" | "FRAMER_AD_EXPERIMENT_INDEPENDENT_HOME_AUDIENCE" | "FRAMER_AD_EXPERIMENT_JOBS_PAGE_AUDIENCE" | "FRAMER_AD_EXPERIMENT_PROJECT_CREATION_AUDIENCE" | "FRAMER_AD_EXPERIMENT_SERVICES_CREATION_AUDIENCE" | "FRAMER_AD_EXPERIMENT_SIDE_NAV_AUDIENCE" | "FRAMER_EXPERT" | "GLORIFY_EXPERT" | "HAS_CUSTOM_EMAIL_DOMAIN" | "HEY_GEN_EXPERT" | "INSTANT_EXPERT" | "INTEGRATION_TEST_USER" | "JITTER_EXPERT" | "JOB_NETWORK_ACCESS_APPROVED" | "KITTL_EXPERT" | "LOTTIEFILES_X_FIGMA_EXPERT" | "LOTTIEFILES_X_FRAMER_EXPERT" | "LOTTIEFILES_X_WEBFLOW_EXPERT" | "LOW_RATED_USER" | "MANUAL_DEMO_USER" | "MANUAL_TEST_USER" | "ORGANIZATION_MEMBER" | "ORGANIZATION_MEMBER_ROLE_ADMIN" | "ORGANIZATION_MEMBER_ROLE_CONTRA_ADMIN" | "PORTFOLIO_DEVELOPER" | "PORTFOLIO_EARLY_ADOPTER" | "QUICK_RESPONDER" | "RELUME_EXPERT" | "REPLO_EXPERT" | "RIVE_EXPERT" | "SOCIAL_FEATURE_ELIGIBLE" | "SPLINE_EXPERT" | "STANDARD_CLIENT" | "TEST_ADMIN" | "TOP_INDEPENDENT_DISCOVERED" | "TOP_INDEPENDENT_OPTED_IN" | "TOP_INDEPENDENT_OPTED_OUT" | "USER_WITH_INQUIRY_AUTO_APPROVAL" | "USER_WITH_INVOICE_AUTO_APPROVAL" | "USER_WITH_JOB_POSTING_AUTO_APPROVAL" | "USER_WITH_PAID_PROJECT_INVITE_AUTO_APPROVAL" | "VISUAL_ELECTRIC_ADS_ANALYTICS_TAB_AUDIENCE" | "VISUAL_ELECTRIC_ADS_EXPERT_PAGE_AUDIENCE" | "VISUAL_ELECTRIC_ADS_INDEPENDENT_HOME_AUDIENCE" | "VISUAL_ELECTRIC_ADS_JOBS_PAGE_AUDIENCE" | "VISUAL_ELECTRIC_ADS_PROJECT_CREATION_AUDIENCE" | "VISUAL_ELECTRIC_ADS_SERVICES_CREATION_AUDIENCE" | "VISUAL_ELECTRIC_ADS_SIDE_NAV_AUDIENCE" | "WEBFLOW_EXPERT" | "WEBSTUDIO_EXPERT" | "WIX_STUDIO_EXPERT" | "WORKSPACE_ADDED_CONTACT" | "%future added value";
export type WaitListNid = "C4C" | "COMMUNITY_FEED" | "EXPERT_NETWORKS" | "FINANCE_INTEGRATION" | "GROWTH_RECOMMENDATIONS" | "HOURLY_ONGOING_PROJECTS" | "INDEPENDENT_PORTFOLIOS_ALPHA" | "OTHER" | "PRO_ANALYTICS" | "RATE_CALCULATOR" | "SLACK_CLIENT_INTEGRATION" | "%future added value";
export type AdminActionsQuery$variables = {
  username: string;
};
export type AdminActionsQuery$data = {
  readonly adminUserProfileByUsername: {
    readonly clientSubscriptionPlanCustomizations: {
      readonly BUILD: {
        readonly boostedJobs: {
          readonly entitlement: number | null;
          readonly expiresAt: ContraAPIScalars.DateTime | null;
        } | null;
        readonly contractFees: {
          readonly entitlement: number | null;
          readonly expiresAt: ContraAPIScalars.DateTime | null;
        } | null;
      } | null;
      readonly GROW: {
        readonly boostedJobs: {
          readonly entitlement: number | null;
          readonly expiresAt: ContraAPIScalars.DateTime | null;
        } | null;
        readonly contractFees: {
          readonly entitlement: number | null;
          readonly expiresAt: ContraAPIScalars.DateTime | null;
        } | null;
      } | null;
      readonly SCALE: {
        readonly boostedJobs: {
          readonly entitlement: number | null;
          readonly expiresAt: ContraAPIScalars.DateTime | null;
        } | null;
        readonly contractFees: {
          readonly entitlement: number | null;
          readonly expiresAt: ContraAPIScalars.DateTime | null;
        } | null;
      } | null;
    } | null;
    readonly emailAddress: string | null;
    readonly id: string;
    readonly rating: {
      readonly autoBasicScore: number;
      readonly autoBonusScore: number;
      readonly autoProjectsScore: number;
      readonly autoServicesScore: number;
      readonly excludeFromDiscover: boolean | null;
      readonly excludeFromMatching: boolean | null;
      readonly flagForImprovement: boolean | null;
      readonly internalNotes: string | null;
    } | null;
    readonly userGroups: ReadonlyArray<UserGroup>;
    readonly userProfile: {
      readonly hubspotContactUrl: string | null;
      readonly id: string;
      readonly organizationV2: {
        readonly hubspotCompanyUrl: string | null;
      } | null;
      readonly topIndependentStatus: TopIndependentStatus;
    };
    readonly waitLists: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly nid: WaitListNid;
        };
      }>;
    };
  } | null;
};
export type AdminActionsQuery = {
  response: AdminActionsQuery$data;
  variables: AdminActionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "username",
    "variableName": "username"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userGroups",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailAddress",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoBasicScore",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoBonusScore",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoProjectsScore",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoServicesScore",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "excludeFromDiscover",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "excludeFromMatching",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flagForImprovement",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internalNotes",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "topIndependentStatus",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hubspotContactUrl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hubspotCompanyUrl",
  "storageKey": null
},
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "entitlement",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "expiresAt",
    "storageKey": null
  }
],
v17 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ClientSubscriptionUsageMeterCustomEntitlement",
    "kind": "LinkedField",
    "name": "boostedJobs",
    "plural": false,
    "selections": (v16/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ClientSubscriptionUsageMeterCustomEntitlement",
    "kind": "LinkedField",
    "name": "contractFees",
    "plural": false,
    "selections": (v16/*: any*/),
    "storageKey": null
  }
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "AdminUserSearchResultClientSubscriptionPlanCustomizations",
  "kind": "LinkedField",
  "name": "clientSubscriptionPlanCustomizations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientSubscriptionPlanCustomizations",
      "kind": "LinkedField",
      "name": "BUILD",
      "plural": false,
      "selections": (v17/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientSubscriptionPlanCustomizations",
      "kind": "LinkedField",
      "name": "GROW",
      "plural": false,
      "selections": (v17/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientSubscriptionPlanCustomizations",
      "kind": "LinkedField",
      "name": "SCALE",
      "plural": false,
      "selections": (v17/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "WaitListConnection",
  "kind": "LinkedField",
  "name": "waitLists",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WaitListEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WaitList",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "nid",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminActionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AdminUserSearchResult",
        "kind": "LinkedField",
        "name": "adminUserProfileByUsername",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileRating",
            "kind": "LinkedField",
            "name": "rating",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "userProfile",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organizationV2",
                "plural": false,
                "selections": [
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v18/*: any*/),
          (v19/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminActionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AdminUserSearchResult",
        "kind": "LinkedField",
        "name": "adminUserProfileByUsername",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileRating",
            "kind": "LinkedField",
            "name": "rating",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "userProfile",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organizationV2",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v18/*: any*/),
          (v19/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "2f08b7d362c1ac125acc54fa82cc013a",
    "metadata": {},
    "name": "AdminActionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "07158395a0213bffce6b10cf83eb32bb";

export default node;
